/* eslint-disable camelcase */
/* eslint-disable dot-notation */
import ApiService from './ApiService'

export default class PurchasesService {
    apiService

    constructor() {
        this.apiService = new ApiService(process.env.VUE_APP_PURCHASES_API)
    }

    async userStatus({ key, userId }) {
        return this.apiService.get('user/status', { key, userId })
    }
}
